var cilMusicNote = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M72,203.517l160-32V381.186h.044Q232,382.588,232,384c0,55.794,48.448,101.186,108,101.186S448,439.794,448,384,399.552,282.814,340,282.814a111.434,111.434,0,0,0-76,29.367V28.483L72,66.883Zm268,111.3c41.906,0,76,31.037,76,69.186s-34.094,69.186-76,69.186S264,422.149,264,384,298.094,314.814,340,314.814ZM104,93.117l128-25.6v71.366l-128,25.6Z' class='ci-primary'/>"];

export { cilMusicNote };

